import * as React from 'react';
import { useState, useMemo } from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { Box, Typography, TextField, makeStyles } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { PAGE_SIZE_LIST } from 'src/app/constant/config';
import { deviceType } from 'src/app/constant/deviceType';
import { timeFilter } from 'src/app/views/manage/StatisticWarehouseTransfer/constance';
import { useSelector } from 'react-redux';
import { useTheme, useMediaQuery } from '@material-ui/core';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

//const labels = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']

const labelsMonth = [
  'Tháng 1',
  'Tháng 2',
  'Tháng 3',
  'Tháng 4',
  'Tháng 5',
  'Tháng 6',
  'Tháng 7',
  'Tháng 8',
  'Tháng 9',
  'Tháng 10',
  'Tháng 11',
  'Tháng 12'
];

const labelsYear = [
  'Năm 2025',
  'Năm 2026',
  'Năm 2027',
  'Năm 2028',
  'Năm 2029',
  'Năm 2030',
  'Năm 2031',
  'Năm 2032',
  'Năm 2033',
  'Năm 2034',
  'Năm 2035',
  'Năm 2036'
];

const options = {
  scales: {
    x: {
      type: 'category',
      grid: {
        display: false
      }
    }
  },
  responsive: true,
  maintainAspectRatio: true,
  plugins: {
    legend: {
      position: 'bottom'
    }
  }
};

const ChartStatistic = ({
  dataStatistics,
  datasets,
  chartTitle,
  labelChart,
  searchRef
}) => {
  const classes = useStyles();
  const [query, setQuery] = useState({
    device_type_id: undefined,
    agency_id: undefined,
    time_to_chart: 2026,
    time_to_search: 2026,
    page: 1,
    page_size: PAGE_SIZE_LIST
  });

  const dataLogin = useSelector(state => state.authSlice.dataLogin);
  const isAgency = useSelector(state => state.authSlice.isAgency);
  const listAgencies = useSelector(state => state.agencySlice.listAgencies);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const agencyInfo = [
    {
      id: dataLogin?.agency?.id,
      name: dataLogin?.agency?.name
    }
  ];

  const listAgenciesForAdmin = useMemo(
    () => [
      ...listAgencies.map(agency => ({
        id: agency.id,
        name: agency.name
      })),
      { id: '', name: 'Tất cả đại lý' }
    ],
    [listAgencies]
  );

  const newListAgencies = isAgency ? agencyInfo : listAgenciesForAdmin;

  const newListDevices = useMemo(
    () => [
      ...deviceType.map(type => ({
        id: type.id,
        name: type.name
      })),
      { id: '', name: 'Tất cả thiết bị' }
    ],
    [deviceType]
  );

  const newListTime = useMemo(
    () => [
      ...timeFilter.map(time => ({
        id: time.value,
        name: time.label
      })),
      { id: '', name: 'Tất cả thời gian' }
    ],
    [timeFilter]
  );

  const labels = useMemo(() => {
    if (query.time_to_chart) return labelsMonth;

    if (isMobile) {
      return labelsYear.slice(0, 4);
    }

    return labelsYear;
  }, [query.time_to_chart, isMobile]);

  const chartDatasets = useMemo(() => {
    if (Array.isArray(datasets) && datasets.length > 0) {
      return datasets.map(item => ({
        label: item?.label || '',
        data: item?.data?.length > 0 ? item.data : [],
        backgroundColor: item?.backgroundColor || '#2d9aff',
        barThickness: isMobile ? 14 : 25,
        maxBarThickness: isMobile ? 18 : 28
      }));
    }

    return [
      {
        label: labelChart,
        data: dataStatistics?.length > 0 ? dataStatistics : [],
        backgroundColor: '#2d9aff',
        barThickness: isMobile ? 20 : 45,
        maxBarThickness: isMobile ? 24 : 50
      }
    ];
  }, [datasets, labelChart, dataStatistics, isMobile]);

  const data = {
    labels,
    datasets: chartDatasets
  };
  const handleFilter = (e, value, type) => {
    if (type === 'deviceType') {
      const queryValue = Object.assign({}, query, {
        device_type_id: value.id
      });
      setQuery(queryValue);
      searchRef(queryValue);
    }
    if (type === 'agencyType') {
      const queryValue = Object.assign({}, query, {
        agency_id: value.id
      });
      setQuery(queryValue);
      searchRef(queryValue);
    }
    if (type === 'timeType') {
      const queryValue = Object.assign({}, query, {
        time_to_chart: value.id,
        time_to_search: value.id
      });
      setQuery(queryValue);
      searchRef(queryValue);
    }
  };

  return (
    <>
      <Box
        style={{
          padding: '15px 0px',
          display: 'flex',
          justifyContent: 'space-between',
          flexDirection: isMobile ? 'column' : 'row',
          alignItems: isMobile ? 'flex-start' : 'center',
          gap: isMobile ? '12px' : 0
        }}
      >
        <Typography
            style={{ fontSize: '16px', fontWeight: '500', color: '#1E2323' }}
          >
            {chartTitle}
        </Typography>

        <Box
          style={{
            display: 'flex',
            width: isMobile ? '100%' : 'auto',
            flexWrap: isMobile ? 'wrap' : 'nowrap',
            gap: '12px'
          }}
        >
          <Autocomplete
            labelId="demo-simple-select-outlined-label"
            id="demo-simple-select-outlined"
            size="small"
            options={newListAgencies || []}
            getOptionLabel={option => option.name || 'Tất cả đại lý'}
            value={(newListAgencies || []).find(
              option => option.id === query.agency_id
            )}
            onChange={(e, value) => handleFilter(e, value, 'agencyType')}
            disableClearable
            renderInput={params => (
              <TextField
                {...params}
                variant="standard"
                placeholder="Tất cả đại lý"
                InputProps={{
                  ...params.InputProps,
                  style: { fontSize: '14px' }
                }}
              />
            )}
            className={classes.customOutline}
            style={{ flex: 1, width: '120px' }}
          />

          <Autocomplete
            labelId="demo-simple-select-outlined-label"
            id="demo-simple-select-outlined"
            size="small"
            options={newListDevices || []}
            getOptionLabel={option => option.name || 'Tất cả thiết bị'}
            value={(newListDevices || []).find(
              option => option.id === query.device_type_id
            )}
            onChange={(e, value) => handleFilter(e, value, 'deviceType')}
            disableClearable
            renderInput={params => (
              <TextField
                {...params}
                variant="standard"
                placeholder="Tất cả thiết bị"
                InputProps={{
                  ...params.InputProps,
                  style: { fontSize: '14px' }
                }}
              />
            )}
            className={classes.customOutline}
            style={{ flex: 1, width: '120px' }}
          />

          <Autocomplete
            labelId="demo-simple-select-outlined-label"
            id="demo-simple-select-outlined"
            size="small"
            options={newListTime || []}
            getOptionLabel={option => option.name || 'Tất cả thời gian'}
            value={(newListTime || []).find(
              option => option.id === query.time_to_chart
            )}
            onChange={(e, value) => handleFilter(e, value, 'timeType')}
            disableClearable
            renderInput={params => (
              <TextField
                {...params}
                variant="standard"
                placeholder="Tất cả thời gian"
                InputProps={{
                  ...params.InputProps,
                  style: { fontSize: '14px' }
                }}
              />
            )}
            className={classes.customOutline}
            style={{ flex: 1, width: '150px' }}
          />
        </Box>
      </Box>
      <Bar options={options} data={data} height={isMobile ? 200 : 90} />
    </>
  );
};

const useStyles = makeStyles(theme => ({
  option: {
    padding: '8px',
    backgroundColor: 'white',
    color: '#333',
    transition: 'background-color 0.2s ease-in-out',
    '&:hover': {
      backgroundColor: '#f0f0f0'
    }
  },
  icon: {
    fill: '#D9042F'
  },
  root: {
    color: '#D9042F'
  },

  button: {
    color: '#858C93',
    '&:hover': {
      boxShadow: 'none',
      background: '#FFF2F2',
      color: '#D9042F'
    },
    '&:active': {
      boxShadow: 'none',
      background: '#fcd1d1',
      color: '#D9042F'
    }
  },
  button_active: {
    background: '#FFF2F2',
    color: '#D9042F'
  },

  customOutline: {
    '& .MuiInput-underline:before': {
      borderBottom: 'none'
    },
    '& .MuiInput-underline:hover:before': {
      borderBottom: 'none !important'
    },
    '& .MuiInput-underline:after': {
      borderBottom: 'none'
    },
    '& .Mui-focused:after': {
      borderBottom: 'none'
    }
  }
}));

export default ChartStatistic;
